import { MessageRetailerOrBrandButton, additionalDataRequiredForContactingRetailerOrBrandCTA } from "../../shared/instantAnswerUtils";
import { orderTermIsNet60 } from "../../utils/orderTermIsNet60";
import { orderWasAlreadyCharged } from "../../utils/orderWasAlreadyCharged";
import { getViewOrderInvoiceCTA } from "./shared";
export var CanceledItemsIA = function CanceledItemsIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(_context) {
      return INVOICE_UPDATES(strictLocalize);
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getDescription(context, strictLocalize);
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getViewOrderInvoiceC;
        return (_getViewOrderInvoiceC = getViewOrderInvoiceCTA(context, strictLocalize)) === null || _getViewOrderInvoiceC === void 0 ? void 0 : _getViewOrderInvoiceC.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getViewOrderInvoiceC2, _getViewOrderInvoiceC3;
        return (_getViewOrderInvoiceC2 = getViewOrderInvoiceCTA(context, strictLocalize)) === null || _getViewOrderInvoiceC2 === void 0 ? void 0 : (_getViewOrderInvoiceC3 = _getViewOrderInvoiceC2.getLink) === null || _getViewOrderInvoiceC3 === void 0 ? void 0 : _getViewOrderInvoiceC3.call(_getViewOrderInvoiceC2, context.brandOrder);
      }
    },
    secondaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _MessageRetailerOrBra;
        return (_MessageRetailerOrBra = MessageRetailerOrBrandButton(context, strictLocalize)) === null || _MessageRetailerOrBra === void 0 ? void 0 : _MessageRetailerOrBra.label;
      },
      onClickFunctionBuilder: function onClickFunctionBuilder(context) {
        var _MessageRetailerOrBra2;
        return (_MessageRetailerOrBra2 = MessageRetailerOrBrandButton(context, strictLocalize)) === null || _MessageRetailerOrBra2 === void 0 ? void 0 : _MessageRetailerOrBra2.onClick;
      }
    },
    additionalRequiredData: additionalDataRequiredForContactingRetailerOrBrandCTA()
  };
};
var INVOICE_UPDATES = function INVOICE_UPDATES(strictLocalize) {
  return strictLocalize({
    id: "sDN15A",
    defaultMessage: [{
      "type": 0,
      "value": "Mise à jour de facture pour les articles annulés"
    }]
  });
};
var getDescription = function getDescription(context, strictLocalize) {
  var brandOrder = context.brandOrder;
  if (!brandOrder) {
    return [CASE_FOR_OTHER_CONDITIONS(strictLocalize)];
  }
  if (orderTermIsNet60(brandOrder)) {
    return [CASE_WHEN_ORDER_HAS_NET60_TERMS(strictLocalize)];
  }
  if (orderWasAlreadyCharged(brandOrder)) {
    return [CASE_WHEN_ORDER_HAS_BEEN_CHARGED_ALREADY(strictLocalize)];
  }
  return [CASE_FOR_OTHER_CONDITIONS(strictLocalize)];
};
var CASE_WHEN_ORDER_HAS_NET60_TERMS = function CASE_WHEN_ORDER_HAS_NET60_TERMS(strictLocalize) {
  return strictLocalize({
    id: "dpscKg",
    defaultMessage: [{
      "type": 0,
      "value": "Étant donné que la commande que vous avez sélectionnée a été passée avec le paiement à 60 jours, les articles signalés seront supprimés de votre facture et ne vous seront pas facturés."
    }]
  });
};
var CASE_WHEN_ORDER_HAS_BEEN_CHARGED_ALREADY = function CASE_WHEN_ORDER_HAS_BEEN_CHARGED_ALREADY(strictLocalize) {
  return strictLocalize({
    id: "kLQyb8",
    defaultMessage: [{
      "type": 0,
      "value": "Étant donné que votre commande a été facturée à l'expédition, nous rembourserons le montant des articles signalés sur la carte enregistrée sur votre compte. Le remboursement apparaîtra sur votre carte dans le délai de traitement habituel."
    }]
  });
};
var CASE_FOR_OTHER_CONDITIONS = function CASE_FOR_OTHER_CONDITIONS(strictLocalize) {
  return strictLocalize({
    id: "ViIRmN",
    defaultMessage: [{
      "type": 0,
      "value": "Pour les commandes passées avec le paiement à 60 jours, les articles signalés seront supprimés de votre facture et ne vous seront pas facturés. Pour les commandes qui ont été facturées à l'expédition, nous rembourserons le montant des articles signalés sur la carte de paiement enregistrée."
    }]
  });
};